import { isDesktop } from "components/utility/page-responsive/PageResponsive";
import findOneColumnParentContainer from "utils/findOneColumnParentContainer";

const stickySectionPageTypes = new Set(["Dimensional Difference Page"]);

const checkIfDisclaimerFits = (event, container, tooltipBox) => {
	// This function make sure there is the required space for the tooltip to fit

	// Sees how much space is between the element and the edge of the window
	const tooltipOffset = container.getBoundingClientRect().top;
	// Tooltip is set display none by default, setting height to 0 and display: block will allow us to get the scrollHeight without flashing the element on screen
	tooltipBox.style.height = 0;
	tooltipBox.style.display = "block";
	const tooltipBoxSize = tooltipBox.scrollHeight + 32;
	// Remove uneeded styles
	tooltipBox.removeAttribute("style");
	// Takes into account header height if we have one
	const headerHeight = document.querySelector(".sticky-header-el")?.offsetHeight || 0;
	const pixelsNeeded = tooltipBoxSize + headerHeight;

	// Adds a class depending on where we need to force the tooltip
	if (tooltipOffset < pixelsNeeded) {
		container.classList.add("force-to-bottom");
	} else {
		container.classList.remove("force-to-bottom");
	}
};

const handleLittleITooltips = (littleITooltips, isReact = false) => {
	littleITooltips.forEach((container) => {
		if (container.classList.contains("react") && !isReact) return;
		let oneColumnParentContainer;
		const tooltip = container.querySelector(".little-i-tooltip>svg");
		const tooltipBox = container.querySelector(".little-i-tooltip-box");
		const tooltipWrapper = container.querySelector(".little-i-tooltip");
		const pagetype = document.body.getAttribute("data-pagetype");
		let updatedZIndex = false;

		const closeLittleI = () => {
			// This prevents the override of "force-to-etc." to make sure the tooltip appears at the right spot
			if (!container.classList.contains("hover")) {
				container.classList.remove("force-to-bottom");
				container.classList.remove("force-to-top");
			}
			// "Closed" is added to force the tooltip box to hide when clicking on it multiple times, otherwise ux feels weird
			container.classList.add("closed");
			container.classList.remove("tooltip-locked");
			if (oneColumnParentContainer) {
				oneColumnParentContainer.container.style.removeProperty("z-index");
				if (!oneColumnParentContainer.container.getAttribute("style")) {
					oneColumnParentContainer.container.removeAttribute("style");
				}
				updatedZIndex = false;
			}
		};

		const checkWindowClickForLittleI = (event) => {
			if (!tooltipWrapper.contains(event.target)) {
				closeLittleI();
				window.removeEventListener("click", checkWindowClickForLittleI);
			}
		};

		const handleMouseEntry = (event) => {
			container.classList.remove("closed");
			// This adds a hover class - needed to control logic in other parts.
			const otherOpenedLittleI = document.querySelector(".little-i.tooltip-locked");
			if (otherOpenedLittleI && otherOpenedLittleI !== container) {
				const otherLittleIParentContainer = findOneColumnParentContainer(
					".little-i.tooltip-locked"
				);
				otherLittleIParentContainer?.container.style.removeProperty("z-index");
				if (!otherLittleIParentContainer.container.getAttribute("style")) {
					otherLittleIParentContainer.container.removeAttribute("style");
				}
				otherOpenedLittleI.classList.remove("tooltip-locked");
			}
			checkIfDisclaimerFits(event, container, tooltipBox);
			// Hover effects can only be seen on desktop >
			if (isDesktop()) {
				container.classList.add("hover");
				if (stickySectionPageTypes.has(pagetype) && !updatedZIndex) {
					oneColumnParentContainer = findOneColumnParentContainer(".little-i.hover");
					oneColumnParentContainer.container.style.zIndex =
						Number(oneColumnParentContainer.containerCSS.zIndex) + 1;
					updatedZIndex = true;
				}
			}
		};

		const handleClick = (event) => {
			// Adds a class "tooltip-locked" to force the tooltip to stay on screen.
			checkIfDisclaimerFits(event, container, tooltipBox);
			if (container.classList.contains("tooltip-locked")) {
				closeLittleI();
			} else {
				// If they click again, remove the "closed" class and lock tooltip again
				container.classList.remove("closed");
				container.classList.add("tooltip-locked");
				if (stickySectionPageTypes.has(pagetype) && !updatedZIndex) {
					oneColumnParentContainer = findOneColumnParentContainer(".little-i.tooltip-locked");
					oneColumnParentContainer.container.style.zIndex =
						Number(oneColumnParentContainer.containerCSS.zIndex) + 1;
					updatedZIndex = true;
				}
				window.addEventListener("click", checkWindowClickForLittleI);
			}
		};

		const handleMouseLeave = () => {
			// Remove control classes when mouse leaves
			container.classList.remove("hover");
			container.classList.remove("closed");
			if (container.classList.contains("tooltip-locked")) {
				// Returns if tooltip is locked to prevent removing needed classes
				return;
			}
			container.classList.remove("force-to-bottom");
			container.classList.remove("force-to-top");
			if (oneColumnParentContainer) {
				oneColumnParentContainer.container.style.removeProperty("z-index");
				if (!oneColumnParentContainer.container.getAttribute("style")) {
					oneColumnParentContainer.container.removeAttribute("style");
				}
				updatedZIndex = false;
			}
		};

		tooltip.addEventListener("mouseenter", handleMouseEntry);
		tooltip.addEventListener("click", handleClick);
		tooltip.addEventListener("mouseleave", handleMouseLeave);
		tooltipBox.addEventListener("mouseenter", handleMouseEntry);
		tooltipBox.addEventListener("mouseleave", handleMouseLeave);
	});
};

export default handleLittleITooltips;
